import { Box, Typography, Container } from '@mui/material';
import { ChemicalListComponent } from './ChemicalListComponent';

export function ContainerCatalogue() {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                backgroundColor: '#f4f7fb',
                backgroundImage: 'linear-gradient(180deg, #eaf1f9 0%, #f7f9fc 360px, #ffffff 760px)',
            }}
        >
            <Box
                sx={{
                    background: 'linear-gradient(115deg, #003883 0%, #064b97 58%, #0875a5 100%)',
                    borderBottom: '4px solid #ee7d11',
                    py: { xs: 3, sm: 4 },
                    px: 2,
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        backgroundImage: 'repeating-linear-gradient(135deg, transparent 0px, transparent 34px, rgba(255,255,255,0.035) 35px, rgba(255,255,255,0.035) 36px)',
                        pointerEvents: 'none',
                    },
                }}
            >
                <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 800,
                            color: '#ffffff',
                            fontSize: { xs: '24px', sm: '32px', md: '40px' },
                            letterSpacing: 0,
                            mb: 1,
                        }}
                    >
                        Chemical Container Catalogue
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'rgba(255, 255, 255, 0.9)',
                            fontSize: '16px',
                            fontWeight: 400,
                            maxWidth: '600px',
                        }}
                    >
                        Browse and manage chemical containers with detailed safety information and hazard identification
                    </Typography>
                </Container>
            </Box>

            <ChemicalListComponent />
        </Box>
    )
}
